// ─────────────────────────────────────────────────────────────
// HarmanaGEL — İlişki (foreign key) isim çözümleyicileri.
//
// Bazı OData entity'lerinde ($expand için) navigation property
// tanımlı değildir (ör. MAGAZA_TAKIPCILERI, ILAN_FIYAT_ALARMLARI).
// Bu durumda satırlardaki KULLANICI_ID / MAGAZA_ID / ILAN_ID /
// KATEGORI_ID değerlerini toplu olarak ("ID in (...)") çekip
// {id: görünenAd} sözlüğü döndüren yardımcılar.
// ─────────────────────────────────────────────────────────────

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return { Authorization: `Bearer ${token}` };
};

// Verilen id listesinden benzersiz, geçerli olanları döndürür.
const uniqIds = (ids) =>
  [...new Set((ids || []).filter((v) => v !== null && v !== undefined && v !== ""))];

/**
 * Genel amaçlı toplu isim çözümleyici.
 * @param {string} entity   OData set adı (ör. "KULLANICILAR")
 * @param {number[]} ids    çözülecek ID'ler
 * @param {string[]} selectFields  ID + gösterilecek alanlar
 * @param {(row:object)=>string} labelFn  satırdan görünen adı üretir
 * @returns {Promise<Object>} { [id]: label }
 */
export const fetchNameMap = async (entity, ids, selectFields, labelFn) => {
  const list = uniqIds(ids);
  if (list.length === 0) return {};
  const map = {};
  // OData $filter uzunluk sınırına takılmamak için 100'erli parçalar.
  const CHUNK = 100;
  for (let i = 0; i < list.length; i += CHUNK) {
    const chunk = list.slice(i, i + CHUNK);
    const filter = `ID in (${chunk.join(",")})`;
    const url =
      `${BASE_URL}/${entity}?$select=${selectFields.join(",")}` +
      `&$filter=${encodeURIComponent(filter)}&$top=${chunk.length}`;
    try {
      const res = await fetch(url, { headers: getHeaders() });
      const json = await res.json();
      (json.value || []).forEach((row) => {
        map[row.ID] = labelFn(row);
      });
    } catch {
      /* isim çözülemezse ID gösterilecek */
    }
  }
  return map;
};

export const fetchUserNames = (ids) =>
  fetchNameMap(
    "KULLANICILAR",
    ids,
    ["ID", "AD_SOYAD", "ISLETME_AD", "CEP_NO"],
    (r) => r.AD_SOYAD || r.ISLETME_AD || r.CEP_NO || `#${r.ID}`
  );

export const fetchMagazaNames = (ids) =>
  fetchNameMap(
    "MAGAZALAR",
    ids,
    ["ID", "MAGAZA_ADI"],
    (r) => r.MAGAZA_ADI || `#${r.ID}`
  );

export const fetchIlanNames = (ids) =>
  fetchNameMap(
    "ILANLAR",
    ids,
    ["ID", "AD"],
    (r) => r.AD || `#${r.ID}`
  );

export const fetchKategoriNames = (ids) =>
  fetchNameMap(
    "KATEGORILER",
    ids,
    ["ID", "AD"],
    (r) => r.AD || `#${r.ID}`
  );
